import axios from "axios";
import ASEUrl from "../../cryptojs/secret";

export default {
  name: "spellingGame",
  data() {
    return {
      // 游戏设置
      targetScore: 10, // 10分（固定）
      wordCount: 10, // 10个单词（固定）

      // 带中文翻译的单词列表
      vocabulary: [
        { english: "apple", chinese: "苹果" },
        { english: "banana", chinese: "香蕉" },
        { english: "cherry", chinese: "樱桃" },
        { english: "dolphin", chinese: "海豚" },
        { english: "elephant", chinese: "大象" },
        { english: "fantastic", chinese: "极好的" },
        { english: "giraffe", chinese: "长颈鹿" },
        { english: "happiness", chinese: "幸福" },
        { english: "incredible", chinese: "难以置信的" },
        { english: "journey", chinese: "旅程" },
        { english: "knowledge", chinese: "知识" },
        { english: "laughter", chinese: "笑声" },
        { english: "mountain", chinese: "山" },
        { english: "notebook", chinese: "笔记本" },
        { english: "opportunity", chinese: "机会" },
        { english: "paradise", chinese: "天堂" },
        { english: "question", chinese: "问题" },
        { english: "rainbow", chinese: "彩虹" },
        { english: "sunshine", chinese: "阳光" },
        { english: "treasure", chinese: "宝藏" },
        { english: "umbrella", chinese: "雨伞" },
        { english: "victory", chinese: "胜利" },
        { english: "wonderful", chinese: "精彩的" },
        { english: "xylophone", chinese: "木琴" },
        { english: "yesterday", chinese: "昨天" },
        { english: "zebra", chinese: "斑马" },
      ],

      // 玩家1数据
      player1Word: "", // 当前单词
      player1DisplayWord: [], // 显示给玩家的单词（带下划线）
      player1MissingIndices: [], // 缺失字母的索引
      player1Selections: {}, // 玩家选择的字母
      player1SelectedPosition: null, // 当前选中的位置
      player1Score: 0, // 得分
      player1AnswerSubmitted: false, // 是否已提交答案
      player1Correct: false, // 答案是否正确
      player1NextWordCountdown: 0, // 下一个单词的倒计时
      player1NextWordTimer: null, // 下一个单词的计时器
      player1RoundsPlayed: 0, // 已完成的回合数
      player1Time: 0, // 用时
      player1Timer: null, // 计时器
      player1Finished: false, // 是否已完成
      player1ReachedTarget: false, // 是否达到目标分数
      player1MissingIndicesWord: {}, // 缺失字母的单词位置
      player1MissingIndicesWordList: [], // 缺失字母的单词位置列表

      // 玩家2数据
      player2Word: "", // 当前单词
      player2DisplayWord: [], // 显示给玩家的单词（带下划线）
      player2MissingIndices: [], // 缺失字母的索引
      player2Selections: {}, // 玩家选择的字母
      player2SelectedPosition: null, // 当前选中的位置
      player2Score: 0, // 得分
      player2AnswerSubmitted: false, // 是否已提交答案
      player2Correct: false, // 答案是否正确
      player2NextWordCountdown: 0, // 下一个单词的倒计时
      player2NextWordTimer: null, // 下一个单词的计时器
      player2RoundsPlayed: 0, // 已完成的回合数
      player2Time: 0, // 用时
      player2Timer: null, // 计时器
      player2Finished: false, // 是否已完成
      player2ReachedTarget: false, // 是否达到目标分数
      player2MissingIndicesWord: {}, // 缺失字母的单词位置
      player2MissingIndicesWordList: [], // 缺失字母的单词位置列表
      // 限时模式数据
      gameTimeRemaining: 0, // 剩余时间

      // 键盘布局（QWERTY）
      keyboardLayout: [
        ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["z", "x", "c", "v", "b", "n", "m"],
      ],
      // 通用数据
      alphabet: "abcdefghijklmnopqrstuvwxyz".split(""), // 字母表
      gameStarted: false, // 游戏是否已开始
      gameOver: false, // 游戏是否结束
    };
  },
  computed: {
    // 判断游戏是否结束
    isGameOver() {
      if (this.selectedGameMode === "timeLimit") {
        return this.timeLimit <= 0; // 限时模式：时间用完
      } else if (this.selectedGameMode === "scoreOnly") {
        return this.player1ReachedTarget || this.player2ReachedTarget; // 分数模式：达到目标分数
      } else if (this.selectedGameMode === "timeTrack") {
        return (
          (this.player1Finished && this.player2Finished) ||
          (this.player1RoundsPlayed >= this.wordCount &&
            this.player2RoundsPlayed >= this.wordCount)
        ); // 计时模式：完成所有单词
      }
      return false;
    },
  },
  methods: {
    queryWordList(){
      const that = this
      axios({
        headers:{
          'Content-Type':'application/x-www-form-urlencoded',
          'Authorization': window.localStorage.getItem('sessionId')
        },
        method: 'GET',
        url: '/v1/screen/'+this.id,
        data:{}
        })
      .then((res) => {
       
        if (typeof res.data === 'string') {
          res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
        } 
          if(res.data.code == 0){
              that.spinShow = false
              that.wordInfo = res.data.data
              let SimpleWords = res.data.data.screen.content || []
             
              // vocabulary
              let vocabulary = []
              SimpleWords.map(item=>{
                let data = {
                  chinese: item.translation, 
                  english: item.word
                }
                vocabulary.push(data)
              })
              that.vocabulary = vocabulary
              // 动态调整题目数量为实际词语数量
              that.questionCount = vocabulary.length
              that.wordCount = vocabulary.length
              console.log(that.vocabulary, '词语数量:', vocabulary.length)
          }else{
               if(res.data.code == 4001){
                  this.$router.push({name:'login',query:{qtype:this.$route.query.qtype}})
              }else{
                  that.$Message.error(res.data.msg);

              }
          }
          })
      .catch((err) => {
          that.$Message.error(err);
      });
    },

    // 开始游戏
    letterStartGame() {
      // 重置玩家数据
      this.resetPlayerData();
      this.questions.length = this.targetScore;
      // 设置拼写游戏
      this.setupPlayerWord(1);
      this.setupPlayerWord(2);
      this.gameState = "playing";
      this.optionsPanelVisible = false;

      // 根据特定模式启动计时器
      if (
        this.selectedGameMode === "timeLimit" ||
        this.selectedGameMode === "scoreOnly"
      ) {
        this.remainingTime = this.timeLimit;
        this.startTimeLimitTimer();
      } else if (this.selectedGameMode === "timeTrack") {
        this.elapsedTime = 0;
        this.startTimeTrackTimer();
      }
    },

    // 重置玩家数据
    letterResetPlayerData() {
      // 玩家1
      this.player1Word = "";
      this.player1DisplayWord = [];
      this.player1MissingIndices = [];
      this.player1Selections = {};
      this.player1SelectedPosition = null;
      this.player1Score = 0;
      this.player1AnswerSubmitted = false;
      this.player1Correct = false;
      this.player1NextWordCountdown = 0;
      this.player1RoundsPlayed = 0;
      this.player1Time = 0;
      this.player1Finished = false;
      this.player1ReachedTarget = false;
      this.player1Completed = false;
      this.player1Sum = 0;
      this.answerCountNumber = 0;
      this.player1MissingIndicesWordList = [];
      // 玩家2
      this.player2Word = "";
      this.player2DisplayWord = [];
      this.player2MissingIndices = [];
      this.player2Selections = {};
      this.player2SelectedPosition = null;
      this.player2Score = 0;
      this.player2AnswerSubmitted = false;
      this.player2Correct = false;
      this.player2NextWordCountdown = 0;
      this.player2RoundsPlayed = 0;
      this.player2Time = 0;
      this.player2Finished = false;
      this.player2ReachedTarget = false;
      this.player2Sum = 0;
      this.player2Completed = false;
      this.player2MissingIndicesWordList = [];

    },

    // 清除所有计时器
    clearAllTimers() {
      if (this.player1NextWordTimer) {
        clearInterval(this.player1NextWordTimer);
        this.player1NextWordTimer = null;
      }

      if (this.player2NextWordTimer) {
        clearInterval(this.player2NextWordTimer);
        this.player2NextWordTimer = null;
      }

      if (this.player1Timer) {
        clearInterval(this.player1Timer);
        this.player1Timer = null;
      }

      if (this.player2Timer) {
        clearInterval(this.player2Timer);
        this.player2Timer = null;
      }

      if (this.gameTimer) {
        clearInterval(this.gameTimer);
        this.gameTimer = null;
      }
    },
    // 启动计时模式的玩家计时器
    startPlayerTimer() {
      this.player1Timer = setInterval(() => {
        this.player1Time++;
      }, 1000);
      this.player2Timer = setInterval(() => {
        this.player2Time++;
      });
      this.gameTimer = setInterval(() => {
        this.elapsedTime++;
      }, 1000);
    },

    // 获取单词的中文含义
    getChineseMeaning(word) {
      const wordObj = this.vocabulary.find((item) => item.english === word);
      return wordObj ? wordObj.chinese : "未知";
    },

    // 设置玩家的拼写游戏单词
    setupPlayerWord(player) {
      if (player === 1) {
        this.player1AnswerSubmitted = false;
        this.player1Correct = false;
        this.player1Selections = {};
        this.player1SelectedPosition = null;

        if (this.player1NextWordTimer) {
          clearInterval(this.player1NextWordTimer);
          this.player1NextWordTimer = null;
        }

        // 为玩家1随机选择一个单词
        const randomIndex = Math.floor(Math.random() * this.vocabulary.length);
        this.player1Word = this.vocabulary[randomIndex].english;

        // 创建带缺失字母的显示单词
        this.createPlayerDisplayWord(1);
      } else {
        this.player2AnswerSubmitted = false;
        this.player2Correct = false;
        this.player2Selections = {};
        this.player2SelectedPosition = null;

        if (this.player2NextWordTimer) {
          clearInterval(this.player2NextWordTimer);
          this.player2NextWordTimer = null;
        }

        // 为玩家2随机选择一个单词
        const randomIndex = Math.floor(Math.random() * this.vocabulary.length);
        this.player2Word = this.vocabulary[randomIndex].english;

        // 创建带缺失字母的显示单词
        this.createPlayerDisplayWord(2);
      }
    },

    // 创建带缺失字母的显示单词
    createPlayerDisplayWord(player) {
      const word = player === 1 ? this.player1Word : this.player2Word;

      // 根据单词长度确定要替换的字母数量
      let lettersToReplace;
      if (word.length <= 4) {
        lettersToReplace = 1;
      } else if (word.length <= 7) {
        lettersToReplace = Math.floor(Math.random() * 2) + 1; // 1-2个字母
      } else {
        lettersToReplace = Math.floor(Math.random() * 3) + 1; // 1-3个字母
      }

      // 创建带缺失字母的显示单词
      const displayWord = word.split("");
      const missingIndices = [];
      const missingIndicesWord = {};

      // 随机选择要替换的索引
      const indices = Array.from({ length: word.length }, (_, i) => i);
      for (let i = 0; i < lettersToReplace; i++) {
        if (indices.length === 0) break;

        const randomIdx = Math.floor(Math.random() * indices.length);
        const indexToReplace = indices.splice(randomIdx, 1)[0];

        missingIndices.push(indexToReplace);
        missingIndicesWord[indexToReplace] = displayWord[indexToReplace];
        displayWord[indexToReplace] = "_";
      }
      console.log("player1DisplayWord", displayWord);
      console.log("player1MissingIndices", missingIndices);
      console.log("missingIndicesWord", missingIndicesWord);
      if (player === 1) {
        this.player1DisplayWord = displayWord;
        this.player1MissingIndices = missingIndices;
        this.player1MissingIndicesWord = missingIndicesWord;
        
      } else {
        this.player2DisplayWord = displayWord;
        this.player2MissingIndices = missingIndices;
        this.player2MissingIndicesWord = missingIndicesWord;
      }
    },
    // 随机取值6位备选字母
    randomLetters(playerVal) {
      let positionWord = playerVal;
      //从alphabet中随机取5个字母
      let randomLetters = [];
      // 复制字母表数组，避免修改原始数组
      const alphabetCopy = [...this.alphabet];
      while (randomLetters.length < 6 && alphabetCopy.length > 0) {
        const randomIndex = Math.floor(Math.random() * alphabetCopy.length);
        const randomLetter = alphabetCopy.splice(randomIndex, 1)[0];
        randomLetters.push(randomLetter);
      }
      if (!randomLetters.includes(positionWord)) {
        let randomIndex = Math.floor(Math.random() * this.randomLetters.length);
        // 替换位置
        randomLetters[randomIndex] = positionWord;
      }
      return randomLetters;
    },
    // 选择要填充的位置
    selectPosition(player, index,state=false,val) {
      console.log('va',val);
      
      console.log("选择位置:", player, index);
      if (player === 1) {
        if (this.player1AnswerSubmitted) return;
        this.player1SelectedPosition = index;
        if (
          this.selectedQuestionType === "letter" &&
          state 
        ) {
          this.player1MissingIndicesWordList = this.randomLetters(
            this.player1MissingIndicesWord[index]
          );
          this.keyboardLayout = [this.player1MissingIndicesWordList];
        }
        console.log(
          "player2SelectedPosition",
          this.player1SelectedPosition,
          this.player1MissingIndicesWordList
        );
      } else {
        if (this.player2AnswerSubmitted) return;
        this.player2SelectedPosition = index;
        if (
          this.selectedQuestionType === "letter" &&
          state
        ) {
          this.player2MissingIndicesWordList = this.randomLetters(
            this.player2MissingIndicesWord[index]
          );
          this.keyboardLayout = [this.player2MissingIndicesWordList];
        }
        console.log(
          "player2SelectedPosition",
          this.player2MissingIndicesWordList
        );
      }
    },

    // 处理键盘字母点击
    handleLetterClick(player, letter) {
      console.log("点击字母:", player, letter);

      if (player === 1) {
        if (
          this.player1SelectedPosition === null ||
          this.player1AnswerSubmitted
        ) {
          console.log("玩家1未选择位置或已提交答案");
          return;
        }

        // 直接更新选择
        this.player1Selections = {
          ...this.player1Selections,
          [this.player1SelectedPosition]: letter,
        };
        let letterIndices1 = [];
        this.player1DisplayWord.forEach((item, index) => {
          if (
            this.selectedQuestionType === "wordSpell" ||
            this.selectedQuestionType === "wordCorrect"
          ) {
            letterIndices1.push(index);
          } else {
            if (item === "_") {
              letterIndices1.push(index);
            }
          }
        });
        if (this.player1SelectedPosition !== this.player1DisplayWord.length) {
          let index = letterIndices1.indexOf(this.player1SelectedPosition);
          let nextIndex = letterIndices1[index + 1];
          this.selectPosition(1, nextIndex);
        }
        console.log("玩家1选择更新:", this.player1Selections);
      } else {
        if (
          this.player2SelectedPosition === null ||
          this.player2AnswerSubmitted
        ) {
          console.log("玩家2未选择位置或已提交答案");
          return;
        }
        console.log("player2SelectedPosition", this.player2SelectedPosition);
        // 直接更新选择
        this.player2Selections = {
          ...this.player2Selections,
          [this.player2SelectedPosition]: letter,
        };
        console.log("player2Selections", this.player2Selections);
        let letterIndices2 = [];
        this.player2DisplayWord.forEach((item, index) => {
          if (
            this.selectedQuestionType === "wordSpell" ||
            this.selectedQuestionType === "wordCorrect"
          ) {
            letterIndices2.push(index);
          } else {
            if (item === "_") {
              letterIndices2.push(index);
            }
          }
        });
        if (this.player2SelectedPosition !== this.player2DisplayWord.length) {
          let index = letterIndices2.indexOf(this.player2SelectedPosition);
          let nextIndex = letterIndices2[index + 1];
          this.selectPosition(2, nextIndex);
        }
        console.log("玩家2选择更新:", this.player2DisplayWord);
      }
    },

    // 处理删除键按下
    handleDeleteKey(player) {
      console.log("删除键:", player);

      if (player === 1) {
        if (
          this.player1SelectedPosition === null ||
          this.player1AnswerSubmitted ||
          !this.player1Selections[this.player1SelectedPosition]
        ) {
          return;
        }

        // 创建一个没有当前选择的新对象
        const newSelections = { ...this.player1Selections };
        delete newSelections[this.player1SelectedPosition];
        this.player1Selections = newSelections;

        console.log("玩家1删除选择:", this.player1Selections);
      } else {
        if (
          this.player2SelectedPosition === null ||
          this.player2AnswerSubmitted ||
          !this.player2Selections[this.player2SelectedPosition]
        ) {
          return;
        }

        // 创建一个没有当前选择的新对象
        const newSelections = { ...this.player2Selections };
        delete newSelections[this.player2SelectedPosition];
        this.player2Selections = newSelections;

        console.log("玩家2删除选择:", this.player2Selections);
      }
    },

    // 检查玩家的答案是否完整
    isPlayerAnswerComplete(player) {
      if (player === 1) {
        return this.player1MissingIndices.every(
          (index) => this.player1Selections[index] !== undefined
        );
      } else {
        return this.player2MissingIndices.every(
          (index) => this.player2Selections[index] !== undefined
        );
      }
    },

    // 提交玩家的答案
    submitAnswer(player, type) {
      // 如果是 yes 按钮点击，显示分数动画
      if (type === 'yes') {
        // 检查是否可以点击（防止重复点击，全局锁定）
        if (!this.canPlayerClick()) {
          return;
        }
        // 标记当前题目已被处理并锁定
        this.markCurrentRoundProcessed();
        this.lockGameClick();
        // 判断当前单词是否正确（偶数回合显示原单词，奇数回合可能有错误字母）
        const isCorrect = this.playerBothRoundsPlayed % 2 === 0;
        this.playAnswerFeedback(isCorrect);
        // 直接触发动画，跳过 showScoreAnimation 的重复检查
        this.triggerScoreAnimation(player, isCorrect);
      }

      if (player === 1) {
        if (this.player1AnswerSubmitted) return;

        // 通过替换缺失字母创建玩家答案
        const playerAnswer = [...this.player1DisplayWord];
        for (const [index, letter] of Object.entries(this.player1Selections)) {
          playerAnswer[parseInt(index)] = letter;
        }

        const playerWord = playerAnswer.join("");
        console.log(
          "玩家1提交答案:",
          playerWord,
          "正确答案:",
          this.player1Word
        );

        // 检查答案是否正确
        this.player1Correct = playerWord === this.player1Word;
        this.player1AnswerSubmitted = true;
        if (type !== "yes") {
          this.playAnswerFeedback(this.player1Correct);
        }

        // 纠错抢答模式下，确认按钮提交时显示分数动画（只有答对才显示+1）
        if (this.selectedQuestionType === "wordSpell" || this.selectedQuestionType === "wordCorrect") {
          if (type !== 'yes' && this.player1Correct) {
            this.showConfirmScoreAnimation(1, true);
          }
        }

        // 更新分数
        if (this.player1Correct) {
          if (this.answerCountNumberInterval) {
            clearInterval(this.answerCountNumberInterval);
            this.answerCountNumberInterval = null;
          }
          this.player1Score++;
          this.player1Sum = this.player1Score * 10;
          // 检查玩家是否在分数模式中达到目标分数
          if (
            this.selectedGameMode === "scoreOnly" &&
            this.player1Score >= this.targetScore
          ) {
            this.player1Completed = true;
          }
        } else {
          // 仅在分数模式中扣分
          if (this.selectedGameMode === "scoreOnly" && this.player1Sum > 0) {
            this.player1Sum -= 5;
          }
          if (this.selectedGameMode === "timeTrack") {
            this.player1Time += 2;
          }
          if (this.selectedQuestionType === "wordSpell") {
              if (this.player1Sum > 0 && type == "yes") {
                this.player1Score--;
                if (this.player1Score < 0) this.player1Score = 0;
              }
              this.player2AnswerSubmitted = false;
              this.player2SelectedPosition = null;
              this.initClearTimer();
              this.clearRaceDelayTimer();
              this.raceDelayTimer = setTimeout(() => {
                  if (this.gameState === 'playing') {
                    this.racePlayerData("2");
                  }
              }, 1000);
              return;
            }
          if (this.selectedQuestionType === "wordCorrect") {
            this.clearRaceDelayTimer();
            this.raceDelayTimer = setTimeout(() => {
              if (this.gameState === 'playing') {
                this.player1SelectedPosition = null;
                this.player1AnswerSubmitted = false;
                this.initClearTimer();
                this.racePlayerData("2");
              }
            }, 1500);
            return;
          }
        }
        console.log(
          "player1RoundsPlayed",
          this.player1RoundsPlayed,
          this.wordCount,
          this.playerBothRoundsPlayed
        );
        // 检查玩家是否在计时模式中完成
        if (
          this.selectedQuestionType === "wordSpell" ||
          this.selectedQuestionType === "wordCorrect"
        ) {
          if (this.playerBothRoundsPlayed + 1 >= this.wordCount) {
            this.player1Completed = true;
            this.player2Completed = true;
            this.gameOver = true;
            this.endGame();
          } else {
            this.startPlayerNextWordCountdown(1, this.player1Correct);
          }
        } else {
          if (this.player1RoundsPlayed + 1 >= this.wordCount) {
            this.player1Completed = true;
            // 停止玩家计时器
            if (this.player1Timer) {
              clearInterval(this.player1Timer);
              this.player1Timer = null;
            }
            // 检查两个玩家是否都完成
            if (this.player1Completed && this.player2Completed) {
              this.gameOver = true;
              this.endGame();
            }
          } else {
            this.startPlayerNextWordCountdown(1, this.player1Correct);
          }
        }
        // 开始下一个单词的倒计时
      } else {
        if (this.player2AnswerSubmitted) return;

        // 通过替换缺失字母创建玩家答案
        const playerAnswer = [...this.player2DisplayWord];
        for (const [index, letter] of Object.entries(this.player2Selections)) {
          playerAnswer[parseInt(index)] = letter;
        }

        const playerWord = playerAnswer.join("");
        console.log(
          "玩家2提交答案:",
          playerWord,
          "正确答案:",
          this.player2Word
        );

        // 检查答案是否正确
        this.player2Correct = playerWord === this.player2Word;
        this.player2AnswerSubmitted = true;
        if (type !== "yes") {
          this.playAnswerFeedback(this.player2Correct);
        }

        // 纠错抢答模式下，确认按钮提交时显示分数动画（只有答对才显示+1）
        if (this.selectedQuestionType === "wordSpell" || this.selectedQuestionType === "wordCorrect") {
          if (type !== 'yes' && this.player2Correct) {
            this.showConfirmScoreAnimation(2, true);
          }
        }

        // 更新分数
        if (this.player2Correct) {
          if (this.answerCountNumberInterval) {
            clearInterval(this.answerCountNumberInterval);
            this.answerCountNumberInterval = null;
          }
          this.player2Score++;
          this.player2Sum = this.player2Score * 10;
          // 检查玩家是否在分数模式中达到目标分数
          if (
            this.selectedGameMode === "scoreOnly" &&
            this.player2Score >= this.targetScore
          ) {
            this.player2Completed = true;
          }
        } else {
          // 仅在分数模式中扣分
          if (this.selectedGameMode === "scoreOnly" && this.player2Sum > 0) {
            this.player2Sum -= 5;
          }
          if (this.selectedGameMode === "timeTrack") {
            this.player2Time += 2;
          }
          if (
            this.selectedQuestionType === "wordCorrect" ||
            this.selectedQuestionType === "wordSpell"
          ) {
            if (this.answerCountNumberInterval) {
              clearInterval(this.answerCountNumberInterval);
              this.answerCountNumberInterval = null;
            }
            if (this.selectedQuestionType === "wordSpell") {
              if (this.player2Sum > 0 && type == "yes") {
                this.player2Score--;
                if (this.player2Score < 0) this.player2Score = 0;
              }
              this.player1AnswerSubmitted = false;
              this.player1SelectedPosition = null;
              this.initClearTimer();
              this.clearRaceDelayTimer();
              this.raceDelayTimer = setTimeout(() => {
                if (this.gameState === 'playing') {
                  this.racePlayerData("1");
                }
              }, 1000);
              return;
            }
            if (this.selectedQuestionType === "wordCorrect") {
              this.clearRaceDelayTimer();
              this.raceDelayTimer = setTimeout(() => {
                if (this.gameState === 'playing') {
                  this.player2SelectedPosition = null;
                  this.player2AnswerSubmitted = false;
                  this.initClearTimer();
                  this.racePlayerData("1");
                }
              }, 1500);
              return;
            }
          }
        }

        // 检查玩家是否在计时模式中完成
        console.log(
          "player2RoundsPlayed",
          this.player2RoundsPlayed,
          this.wordCount,
          this.playerBothRoundsPlayed
        );
        // 单词拼写
        if (
          this.selectedQuestionType === "wordSpell" ||
          this.selectedQuestionType === "wordCorrect"
        ) {
          if (this.playerBothRoundsPlayed + 1 >= this.wordCount) {
            this.player1Completed = true;
            this.player2Completed = true;
            this.gameOver = true;
            this.endGame();
          } else {
            this.startPlayerNextWordCountdown(2, this.player2Correct);
          }
        } else {
          if (this.player2RoundsPlayed + 1 >= this.wordCount) {
            this.player2Completed = true;
            // 停止玩家计时器
            if (this.player2Timer) {
              clearInterval(this.player2Timer);
              this.player2Timer = null;
            }
            // 检查两个玩家是否都完成
            if (this.player1Completed && this.player2Completed) {
              this.gameOver = true;
              this.endGame();
            }
          } else {
            // 开始下一个单词的倒计时
            this.startPlayerNextWordCountdown(2, this.player2Correct);
          }
        }
      }
    },

    // 开始下一个单词的倒计时
    startPlayerNextWordCountdown(player, state = false) {
      if (player === 1) {
        let nextFunRound = () => {
          // 增加已玩回合数
          this.player1RoundsPlayed++;
          // 检查游戏是否结束
          if (this.isGameOver) {
            this.gameOver = true;
          } else if (!this.player1Finished) {
            // 移动到玩家1的下一个单词
            if (
              this.selectedQuestionType === "wordSpell" ||
              this.selectedQuestionType === "wordCorrect"
            ) {
              this.refreshRaceWord();
            } else {
              this.setupPlayerWord(1);
            }
          }
        };
        let nextTimer = () => {
          this.player1NextWordCountdown = 3; // 3秒倒计时
          this.player1NextWordTimer = setInterval(() => {
            this.player1NextWordCountdown--;
            if (this.player1NextWordCountdown <= 0) {
              clearInterval(this.player1NextWordTimer);
              this.player1NextWordTimer = null;
              nextFunRound();
            }
          }, 1000);
        };
        if (this.selectedQuestionType === "wordCorrect") {
          this.playerBothRoundsPlayed++;
          nextFunRound();
        } else if (this.selectedQuestionType === "wordSpell") {
          this.playerBothRoundsPlayed++;
          // 延迟进入下一轮，与+1动画有缓冲效果
          setTimeout(() => {
            nextFunRound();
          }, 800);
        } else {
          if (state) {
            nextFunRound();
          } else {
            nextTimer();
          }
        }
      } else {
        let nextFunRound = () => {
          // 增加已玩回合数
          this.player2RoundsPlayed++;
          // 检查游戏是否结束
          if (this.isGameOver) {
            this.gameOver = true;
          } else if (!this.player2Finished) {
            // 移动到玩家2的下一个单词
            if (
              this.selectedQuestionType === "wordSpell" ||
              this.selectedQuestionType === "wordCorrect"
            ) {
              this.refreshRaceWord();
            } else {
              this.setupPlayerWord(2);
            }
          }
        };
        let nextTimer = () => {
          this.player2NextWordCountdown = 3; // 3秒倒计时
          this.player2NextWordTimer = setInterval(() => {
            this.player2NextWordCountdown--;
            if (this.player2NextWordCountdown <= 0) {
              clearInterval(this.player2NextWordTimer);
              this.player2NextWordTimer = null;
              nextFunRound();
            }
          }, 1000);
        };
        if (this.selectedQuestionType === "wordCorrect") {
          this.playerBothRoundsPlayed++;
          nextFunRound();
        } else if (this.selectedQuestionType === "wordSpell") {
          this.playerBothRoundsPlayed++;
          // 延迟进入下一轮，与+1动画有缓冲效果
          setTimeout(() => {
            nextFunRound();
          }, 800);
        } else {
          if (state) {
            nextFunRound();
          } else {
            nextTimer();
          }
        }
      }
    },
  },
    created() {
    this.id = this.$route.query.id
    console.log(this.id)
    this.queryWordList()
  },
  beforeDestroy() {
    // 组件销毁时清理所有计时器
    this.clearAllTimers();
  },
  watch: {
    isGameOver(newValue) {
      if (newValue) {
        this.gameOver = true;
        this.clearAllTimers();
      }
    },
  },
};
